import React, { useState } from "react";
import Modal from "../../components/Modal/Modal";
import { Spinner, fmt, friendlyDate, recordingSeconds } from "../Notes/notesShared";
import { AiIc } from "./aiShared";
import "../Notes/notes.css";
import "./aiTools.css";

// m4a recordings are hidden because none of the tools can open them on the web.
const HIDDEN_EXTENSIONS = ["m4a"];

const fileNameOf = (audio) => audio?.audio?.fileName || "Recording";
const extensionOf = (audio) => (fileNameOf(audio).includes(".") ? fileNameOf(audio).split(".").pop().toLowerCase() : "");

// One picker for every audio tool, so Import Audio sits in the same place whichever tool opened it.
const RecordingPickerModal = ({ title, subtitle, cta, tone, recordings, loading, onImport, onContinue, onClose }) => {
    const [query, setQuery] = useState("");
    const [selectedId, setSelectedId] = useState(null);

    const q = query.toLowerCase().trim();
    const available = recordings.filter((audio) => !HIDDEN_EXTENSIONS.includes(extensionOf(audio)));
    const list = available.filter((audio) => !q || fileNameOf(audio).toLowerCase().includes(q));
    const selected = available.find((audio) => audio._id === selectedId);

    return (
        <Modal onClose={onClose} modaltxt={title}>
            <div className={`nt nt-modal ai-picker vr-tone-${tone || "indigo"}`}>
                <p className="ai-sub">{subtitle || "Pick one of your recordings, or import an audio file."}</p>

                <button type="button" className="ai-opt" onClick={onImport}>
                    <span className="ai-oc tone"><AiIc name="import" /></span>
                    <span className="nt-grow">
                        <span className="ai-ot">Import Audio</span>
                        <span className="ai-os">Choose an audio file from your device.</span>
                    </span>
                    <span className="ai-opt-chev"><AiIc name="chev" size="s" /></span>
                </button>

                <div className="nt-caps ai-picker-label">Your recordings</div>
                <div className="nt-search ai-search">
                    <AiIc name="search" size="s" />
                    <input placeholder="Search recordings" value={query} onChange={(e) => setQuery(e.target.value)} />
                </div>

                <div className="ai-list">
                    {list.map((audio) => {
                        const noteCount = audio?.notes?.length || 0;
                        return (
                            <button
                                type="button"
                                key={audio._id}
                                className={`ai-item ${selectedId === audio._id ? "sel" : ""}`}
                                onClick={() => setSelectedId(audio._id)}
                            >
                                <span className="nt-av rec"><AiIc name="mic" /></span>
                                <span className="nt-grow">
                                    <span className="nt-title nt-block">{fileNameOf(audio)}</span>
                                    <span className="nt-sub">{friendlyDate(audio.createdAt)} • {fmt(recordingSeconds(audio))}</span>
                                    {(noteCount > 0 || audio.isFavourite) && (
                                        <span className="ai-pills">
                                            {noteCount > 0 && <span className="nt-tag amber"><AiIc name="note" size="s" />{noteCount} note{noteCount > 1 ? "s" : ""}</span>}
                                            {audio.isFavourite && <span className="nt-tag ai-tag-green"><AiIc name="star" size="s" />Favorite</span>}
                                        </span>
                                    )}
                                </span>
                                <span className="ai-radio" />
                            </button>
                        );
                    })}
                    {!list.length && (
                        <p className="nt-tiny-muted ai-list-empty">
                            {loading ? <Spinner /> : q ? "No recordings match this search." : "No recordings yet."}
                        </p>
                    )}
                </div>

                <button
                    type="button"
                    className="nt-btn block ai-cta"
                    disabled={!selected}
                    onClick={() => onContinue(selected)}
                >
                    {cta}
                </button>
            </div>
        </Modal>
    );
};

export default RecordingPickerModal;
